import { render, staticRenderFns } from "./UserOverallInfo.vue?vue&type=template&id=5c4d4158&scoped=true&"
import script from "./UserOverallInfo.vue?vue&type=script&lang=js&"
export * from "./UserOverallInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserOverallInfo.vue?vue&type=style&index=0&id=5c4d4158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d4158",
  null
  
)

export default component.exports